<template>
  <footer class="footer">
    <div class="footer__background"></div>
    <!-- Фон обрывка и шума -->

    <div v-if="!isAdaptiveMobile" class="footer__content">
      <div class="footer__content-top">
        <div class="footer__content-top-left">
          <a
            href="/terms"
            class="underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Пользовательское соглашение
          </a>
          <a href="/privacy" target="_blank" rel="noopener noreferrer">
            Политика конфиденциальности
          </a>
        </div>
        <div class="footer__legal-info">
          <p>ООО "ТРИППИ"</p>
          <p>ИНН: 7000022367</p>
          <p>ОГРН: 1247000009728</p>
          <p>634030, г. Томск,</p>
          <p>ул. Энтузиастов 41, кв. 65</p>
        </div>
        <div class="footer__content-top-right">
          <a class="footer__logo" href="/">
            <img
              src="@assets/svg/footer-logo.svg"
              alt="footer-logo"
              width="174"
              height="72"
            />
          </a>
          <p class="footer__email">
            <a
              :href="'mailto:' + $links.email"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ $links.email }}
            </a>
          </p>
        </div>
      </div>
      <div class="underline-big"></div>
      <div class="footer__content-bottom">
        <div class="footer__content-bottom-left">
          <p>Разработано в Asap Education</p>
          <p>
            *Instagram - проект Meta Platforms Inc, деятельность которой
            запрещена на территории РФ
          </p>
        </div>
        <div class="footer__content-bottom-right">
          <a :href="$links.youtube" target="_blank" rel="noopener noreferrer">
            <img
              src="@assets/svg/Icon-Youtube.svg"
              alt="YouTube icon"
              width="60"
              height="60"
            />
          </a>
          <a
            class="with-dot"
            :href="$links.instagram"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="@assets/svg/Icon-Instagram.svg"
              alt="Instagram icon"
              width="60"
              height="60"
            />
          </a>
          <a
            :href="$links.telegramChannel"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="@assets/svg/Icon-Telegram.svg"
              alt="Telegram icon"
              width="60"
              height="60"
            />
          </a>
        </div>
      </div>
    </div>

    <div v-else class="footer__content">
      <a class="footer__logo" href="/">
        <img
          src="@assets/svg/footer-logo.svg"
          alt="footer-logo"
          width="174"
          height="72"
        />
      </a>
      <div class="footer__legal-info">
        <p>ООО "ТРИППИ"</p>
        <p>ИНН: 7000022367</p>
        <p>ОГРН: 1247000009728</p>
        <p>634030, г. Томск,</p>
        <p>ул. Энтузиастов 41, кв. 65</p>
      </div>
      <p class="footer__email">
        <a
          :href="'mailto:' + $links.email"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ $links.email }}
        </a>
      </p>
      <div class="footer__networks">
        <a
          href="https://www.youtube.com/channel/UC8RtVUCxeXOs_0yz4JyMbBg"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="@assets/svg/Icon-Youtube.svg"
            alt="YouTube icon"
            width="60"
            height="60"
          />
        </a>
        <a
          class="with-dot"
          :href="$links.instagram"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="@assets/svg/Icon-Instagram.svg"
            alt="Instagram icon"
            width="60"
            height="60"
          />
        </a>
        <a
          :href="$links.telegramChannel"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="@assets/svg/Icon-Telegram.svg"
            alt="Telegram icon"
            width="60"
            height="60"
          />
        </a>
      </div>
      <p class="footer__warning">
        *Instagram - проект Meta Platforms Inc, деятельность которой запрещена
        на территории РФ
      </p>
      <div class="footer__links">
        <a
          href="/terms"
          class="underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          Пользовательское соглашение
        </a>
        <a href="/privacy" target="_blank" rel="noopener noreferrer">
          Политика конфиденциальности
        </a>
      </div>
      <div class="underline-big"></div>
      <p class="Asap">Разработано в Asap Education</p>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      isAdaptiveMobile: window.innerWidth <= 1024,
    };
  },
  methods: {
    updateFooterView() {
      this.isAdaptiveMobile = window.innerWidth <= 1024;
    },
  },
  mounted() {
    window.addEventListener("resize", this.updateFooterView);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateFooterView);
  },
};
</script>
<style lang="scss">
.footer {
  position: relative;
  background-color: $blue;
  width: 100%;
  overflow: hidden;
  z-index: 0;
  height: 366px;
  // margin-top: 50px;
  margin-top: auto; // ПРИЖИМАЕМ футер вниз

  &__background {
    position: absolute;
    top: 0; /* Начинается с верхней части футера */
    left: 0;
    width: 102%;
    height: 100%;
    z-index: -1; /* Фон находится под содержимым */

    /* Обрывок страницы */
    &::before {
      content: "";
      position: absolute;
      top: 0px; /* Смещение выше футера */
      left: 0;
      width: 100%;
      height: 40px;
      background-image: url("@assets/svg/paper-for-footer.svg");
      background-repeat: no-repeat;
      background-size: cover; /* Растягиваем обрывок на всю ширину */
      background-position: top;
    }

    /* Шум только на обрывке */
    &::after {
      content: "";
      position: absolute;
      top: 0; /* Начинается с верхней части футера */
      left: 0;
      width: 100%;
      height: 100%;
      background-image: url("@assets/svg/noice.svg");
    }
  }
  &__content {
    padding: 70px 117px 45px;
    &-top {
      height: 117px;
      display: flex;
      justify-content: space-between;
      position: relative; /* Добавляем relative для ::after */
      &-left {
        display: flex;
        flex-direction: column;
        gap: 14px;
        a {
          position: relative;
          text-decoration: none;
          color: inherit;
          color: $white;
          @include manrope(400);
          font-size: 24px;
          align-self: stretch;

          &::after {
            content: "";
            position: absolute;
            left: 0;
            top: 100%;
            width: 0;
            height: 100%;
            background-image: url("@assets/svg/underline.svg"); /* Ваш SVG-файл */
            background-repeat: no-repeat;
            transition: width 0.1s ease; /* Плавный переход ширины */
          }

          &:hover::after,
          &:active::after {
            width: 100%; /* Линия подчеркивания появляется при наведении или нажатии */
          }
        }
      }

      &-right {
        display: flex;
        flex-direction: column;
      }
    }
    &-bottom {
      display: flex;
      justify-content: space-between;
      margin-top: 34px;

      &-left {
        display: flex;
        flex-direction: column;
        text-align: left;
        gap: 3px;
      }
      &-left p {
        font-size: 20px !important;
      }

      &-right {
        display: flex;
        justify-content: flex-end;
        gap: 20px;
      }
    }
  }

  p {
    color: $white;
    @include manrope(400);
    align-self: stretch;
    font-size: 24px;
  }

  &__legal-info {
    margin-left: auto;
    margin-right: 100px;
    p {
      text-align: left;
      font-size: 20px;
      // line-height: 32.78px;
    }
  }

  &__logo {
    display: flex;
    justify-content: center;
  }

  &__logo img {
    width: 174px;
    height: auto;
    aspect-ratio: 174 / 72;
  }

  &__email {
    a {
      text-decoration: none;
      color: $white;
      font-size: 20px;
      &:hover {
        color: darken($white, 10%); /* Делаем цвет чуть темнее на 20% */
      }
    }
  }
}

.underline {
  &-big {
    position: relative;
    height: 5px;
    margin-top: 15px;
    &::after {
      content: "";
      position: absolute;
      bottom: -15px;
      left: 0;
      width: 100%;
      height: 10px;
      background-image: url("@assets/svg/underline-big.svg");
      background-repeat: no-repeat;
      background-size: contain;
    }
  }
}

.with-dot {
  position: relative;
  &::after {
    content: "";
    position: absolute;
    top: -12px;
    right: -12px;
    width: 17px;
    height: 17px;
    background-image: url("@assets/svg/dot.svg");
    background-repeat: no-repeat;
    background-size: contain;
  }
}
@media (max-width: 1600px) and (min-width: 1024px) {
  .footer {
    &__content {
      padding: 50px 70px 30px; /* Уменьшаем отступы для этого разрешения */

      &-bottom {
        p {
          font-size: 20px;
        }
      }
    }
    &__legal-info {
      margin-left: auto;
      margin-right: 30px;
    }
  }
}
@media (max-width: 1024px) and (min-width: 768px) {
  .footer {
    height: auto;
    &__content {
    }
    &__networks {
      display: flex;
      justify-content: center;
      gap: 15px;
      margin-top: 26px;
      margin-bottom: 20px;
    }

    &__links {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-bottom: 36px;

      a {
        position: relative;
        display: inline-block;
        color: inherit;
        @include manrope(400);
        font-size: 24px;
        color: $white;
        text-decoration: none;
        &:after {
          content: "";
          position: absolute;
          left: 11%;
          top: 100%;
          width: 0;
          height: 100%;
          background-image: url("@assets/svg/underline.svg"); /* Ваш SVG-файл */
          background-repeat: no-repeat;
          transition: width 0.1s ease; /* Плавный переход ширины */
        }

        &:hover::after,
        &:active::after {
          width: 100%; /* Линия подчеркивания появляется при наведении или нажатии */
        }
      }
    }
    &__legal-info {
      margin: 10px 0 20px 0;
      p {
        text-align: center;
        font-size: 20px;
      }
    }
  }
  .underline-big {
    display: none;
  }
  .Asap {
    font-size: 20px;
  }

  .footer .footer__warning {
    font-size: 20px;
    margin-bottom: 36px;
  }
}

@media (max-width: 768px) {
  .footer {
    height: auto;

    p {
      font-size: 16px;
    }

    &__content {
      padding: 45px 49px 25px 49px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    &__logo {
      width: 136px;
      height: auto;
    }
    &__email {
      margin-bottom: 10px;
      a {
        font-size: 16px;
      }
    }
    &__networks {
      display: flex;
      justify-content: center;
      gap: 15px;
      margin-top: 26px;
      margin-bottom: 20px;
    }
    &__legal-info {
      margin: 10px 0 20px 0;
      p {
        text-align: center;
        font-size: 16px;
      }
    }
    &__warning {
      p {
        font-size: 16px;
      }
    }
    &__links {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-bottom: 36px;
      margin-top: 35px;
      a {
        position: relative;
        display: inline-block;
        color: inherit;
        @include manrope(400);
        font-size: 18px;
        color: $white;
        text-decoration: none;
        white-space: nowrap;
        &:after {
          content: "";
          position: absolute;
          left: 0%;
          top: 100%;
          width: 0;
          height: 100%;
          background-image: url("@assets/svg/underline.svg"); /* Ваш SVG-файл */
          background-repeat: no-repeat;
          transition: width 0.1s ease; /* Плавный переход ширины */
        }

        &:hover::after,
        &:active::after {
          width: 100%; /* Линия подчеркивания появляется при наведении или нажатии */
        }
      }
    }
  }
  .Asap {
    font-size: 20px;
  }
}
</style>
